import { BaseModel } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class VerificationSendingOtpModel extends BaseModel {
  @Expose() appId!: string;

  @Expose() otpCode!: string;

  @Expose() last4NRIC!: string;
}
